<div class="main-container">
    <div class="modal-header">
        <img src="../../../assets/svg/close-button.svg" class="modal-close-btn" (click)="close(false);$event.stopPropagation()">
    </div>
    <div class="modal-body">
        <app-collector></app-collector>
    </div>
</div>